const year = new Date().getFullYear();

export default function appStartup() {
    console.log(
        `%c\n${'*'.repeat(60)}`,
        "font-size: 1.5em; color: gray;"
    );
    console.log(
        `%c ${import.meta.env.VITE_APP_TITLE} - Version ${__APP_VERSION__}`,
        "font-size: 1.8em; font-weight: bold;"
    );
    console.log(
        `%c ${import.meta.env.VITE_APP_DESCRIPTION}`,
        "font-size: 1.25em;"
    );
    console.log(
        `%c Copyright (c) ${year}, Neutronix Corporation. All rights reserved.`,
        "font-size: 1.25em;"
    );
    console.log(
        `%c\n${'*'.repeat(60)}`,
        "font-size: 1.5em; color: gray;"
    );

    if (!(window as any).debug_mode_active) {
        console.log(
            "%c*** STOP! ***",
            "color: red; text-shadow: 1px 0 0 #000, 0 -1px 0 #000, 0 1px 0 #000, -1px 0 0 #000; font-size: 10em; font-weight: bold"
        );
        console.log(
            "%cThis area is for developer use only. If you are not a developer, you should not be doing anything here. Do not paste any code.\n",
            "font-size: 2em;"
        );
    } else {
        console.log(
            "%c*** DEBUG MODE ACTVE ***",
            "color: red; text-shadow: 1px 0 0 #000, 0 -1px 0 #000, 0 1px 0 #000, -1px 0 0 #000; font-size: 10em; font-weight: bold"
        );
        console.log(
            "%cThis area is for developer use only. If you are not a developer, you should not be doing anything here. Do not paste any code.\n",
            "font-size: 2em;"
        );
    }
}

